import { render } from "./ListUbahLokasiView.vue?vue&type=template&id=046660ec"
import script from "./ListUbahLokasiView.vue?vue&type=script&lang=js"
export * from "./ListUbahLokasiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__